import { defineFcm } from '../shared/factory';

export const FCM_SPH_CONTACT_DECISION_MAKER_ENABLED = defineFcm('sph_contact_decision_maker_enabled')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		supportedGroups: { locales: true, countries: true },
		context: 'Supporter → DM Outreach',
		description:
			'Kill switch for the contact-decision-maker surface on Signed Petition Home, AND-ed with the `sph_contact_decision_maker` experiment: both must be on for the checklist item to render. It cannot enable the surface on its own — outside staging and production the experiment resolves to control, so QA still needs `?exo.sph_contact_decision_maker=treatment:true`. US + English only for the MVP pilot — set `true` on BOTH the en-US locale row and the US country row; either one alone leaves the surface off.',
		mergeLogic:
			'True only when both the locale row and the country row are true — the global row cannot enable it on its own. Mirrors `contact_decision_maker`, the middle-end gate for the same feature.',
	});
